"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _formContext = require("../form-context");

var _field = require("../field");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RadioGroupComponent = function RadioGroupComponent(_ref) {
  var name = _ref.name,
      children = _ref.children,
      getValue = _ref.getValue,
      getErrors = _ref.getErrors,
      setValue = _ref.setValue,
      setTouched = _ref.setTouched,
      _onChange = _ref.onChange;
  var childApi = {
    name: name,
    getValue: getValue,
    setTouched: setTouched,
    onChange: function onChange(event) {
      event.persist();
      var rawValue = event.currentTarget.getAttribute('value');
      var value = rawValue ? (0, _helpers.jsonToValue)(rawValue) : null;
      setValue(value, function () {
        if (_onChange) {
          _onChange(event);
        }
      });
    }
  };
  return _react["default"].createElement(_formContext.ContextRadioGroup.Provider, {
    value: childApi
  }, children);
};

RadioGroupComponent.displayName = 'RadioGroup';
var RadioGroup = (0, _field.Field)(RadioGroupComponent);
exports.RadioGroup = RadioGroup;